"use client";

import { usePathname } from "next/navigation";

/**
 * Suppresses the whole third-party tracker stack on the password-gated
 * `/private` pages.
 *
 * Those pages are shared outside the company, and everything in the root layout
 * would otherwise run on them: Amplitude session replay is at sampleRate 1, so
 * the full DOM of a confidential report would be uploaded, and GTM / the X and
 * LinkedIn pixels would ship the report's URL and title to three ad vendors —
 * none of which were given the password. The unlock form itself would also be
 * rendered on a page executing five third-party scripts.
 *
 * `usePathname()` resolves during SSR in the App Router, so the trackers are
 * absent from the initial HTML too, not just hidden after hydration.
 */
export default function AnalyticsGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (pathname === "/private" || pathname?.startsWith("/private/")) return null;
  return <>{children}</>;
}
